import { gql } from "@apollo/client";

import MeetingTranscriptFragment from "@graphql/meeting-transcript-fragment";

export default gql`
  ${MeetingTranscriptFragment}
  query getMeetingTranscriptQuery($meetingId: Int!) {
    meeting(meetingId: $meetingId) {
      id
      startDatetime
      hasTranscript
      endDatetime
      isRecurring
      hasBotInMeeting
      botIsRecording
      botStatus
      draft
      botIsWaitingToJoinMeeting
      notesSummary
      botParticipationDetails {
        reason
        willBotJoin
        joinBecauseOfParticipants {
          name
        }
      }
      organization {
        id
        name
        effectivePricingTier
        enableMeetingSummarization
        enableMeetingBot
      }
      meetingGroup {
        id
        addTranscriptionBotToMeetingsByDefault
        meetingBotSetting
        canUpdate {
          permission
        }
      }
      videoConferenceType
      ...MeetingTranscriptFragment
    }
  }
`;
